<template>
  <div class="form">
    <b-modal class="custom-modal" v-model="showModal" title="Wróć do strony głównej" @ok="goBack">
      <p>Powrót na stronę główną spowoduje utratę wszystkich udzielonych odpowiedzi. Formularz będzie należało wypełnić ponownie.</p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button class="btn-modal" @click="cancel">Kontynuuj wypełnianie formularza</b-button>
        <b-button class="btn-modal red" @click="ok">Wróć do strony głównej</b-button>
      </template>
    </b-modal>
    <svg class="shape-1" xmlns="http://www.w3.org/2000/svg" width="241" height="172" viewBox="0 0 241 172" fill="none">
      <path d="M137.398 27.4683C146.079 29.7416 154.752 30.0607 163.325 30.8532C181.781 32.5572 200.238 34.6108 218.83 34.257C222.593 34.182 226.195 34.8481 229.577 36.626C237.487 40.7742 241.894 49.4812 240.576 58.4554C239.278 67.2032 232.287 74.3871 223.435 75.7351C220.389 76.1985 217.28 76.1477 214.192 76.2204C196.214 76.6543 178.391 74.5778 160.509 73.2216C159.302 73.123 158.055 73.1069 156.869 73.2756C156.603 73.3177 156.116 74.5126 156.281 74.6972C157.739 76.2761 159.258 77.8137 160.879 79.2686C170.564 87.9569 180.29 96.6041 189.975 105.292C191.821 106.952 193.648 108.653 195.229 110.54C201.351 117.925 201.897 127.818 196.75 135.674C191.888 143.098 182.818 146.545 173.995 144.334C169.696 143.258 166.047 141.008 162.764 138.058C146.636 123.549 130.548 109 114.359 94.5538C109.27 90.0253 103.896 85.827 98.6036 81.5461C97.7011 80.8087 96.5316 79.7842 95.3492 80.8993C94.7988 81.4156 94.5571 82.5067 94.5396 83.3297C94.4068 92.0323 94.2535 100.735 94.3048 109.457C94.3819 125.462 91.2663 140.964 86.9841 156.265C86.2367 158.921 85.2032 161.62 83.7386 163.929C76.9038 174.61 61.7671 174.416 55.0201 163.681C53.0043 160.479 51.7851 156.965 51.6693 153.139C51.5096 148.47 51.309 143.821 51.4152 139.151C51.7338 125.161 52.2162 111.17 52.6167 97.1792C52.6704 95.0189 52.6422 92.8383 52.5322 90.6581C52.4663 89.3828 50.868 88.5244 49.7862 89.1866C47.6841 90.4901 45.623 91.8757 43.5825 93.2613C30.8297 102.05 17.9947 110.715 4.64539 118.559C0.910038 120.753 -2.86634 122.906 -6.80783 124.648C-15.038 128.298 -23.6489 128.369 -32.2672 126.363C-34.9079 125.755 -37.5715 124.489 -39.7861 122.913C-49.3419 116.096 -48.7764 102.475 -38.8166 96.3095C-36.1633 94.6749 -33.242 93.6565 -30.176 93.0491C-26.783 92.3787 -23.72 90.9278 -20.9455 88.8608C-6.58387 78.0918 7.77767 67.3022 22.1186 56.4716C22.5266 56.1616 22.5854 55.4002 22.8084 54.844C21.677 53.0376 19.6322 53.2094 17.9538 52.8862C-2.41144 49.1112 -22.7764 45.4391 -43.1616 41.8082C-45.8837 41.3241 -48.7266 41.3959 -51.4487 40.9118C-54.7848 40.3476 -58.2229 39.8248 -61.3565 38.6633C-68.996 35.8102 -73.7461 28.6884 -73.8357 20.7067C-73.9269 12.293 -68.9819 5.11628 -60.9131 2.10475C-57.1136 0.692393 -53.1474 0.164044 -49.0983 -0.0765704C-39.1188 -0.667332 -29.3768 0.964564 -19.6547 2.78168C-11.7951 4.25564 -3.91518 5.66783 3.92384 7.10073C4.58915 4.36225 2.76513 3.36066 1.55391 2.11004C-9.90123 -9.6785 -21.3563 -21.4671 -32.8726 -33.1937C-38.1074 -38.5445 -42.6281 -44.4328 -46.4758 -50.8583C-48.7597 -54.6767 -49.9197 -58.8076 -49.772 -63.2929C-49.3681 -76.3166 -36.4258 -83.6038 -25.2139 -76.9575C-22.3033 -75.2397 -19.6976 -72.9654 -17.1737 -70.6908C-1.25081 -56.4288 14.6722 -42.1257 30.4933 -27.7399C38.3114 -20.6495 46.3942 -13.9099 54.7622 -7.50033C55.5005 -6.94749 56.2592 -6.41528 57.0586 -5.92438C58.8011 -4.84021 60.2104 -5.42122 60.2855 -7.31413C60.379 -9.80372 60.3497 -12.2929 60.3613 -14.7822C60.2964 -33.1324 60.3337 -51.4831 60.1256 -69.8328C60.0624 -76.1277 60.8384 -82.261 62.2284 -88.3142C64.001 -96.0351 68.3779 -101.914 75.9975 -104.677C90.0519 -109.787 105.246 -99.1023 103.663 -84.1817C101.168 -60.8645 103.009 -37.5832 102.396 -14.2931C102.361 -12.7295 102.326 -11.1865 102.413 -9.62327C102.563 -7.52543 101.571 -4.76524 103.518 -3.55837C105.773 -2.14685 107.359 -4.78571 108.93 -6.02561C124.024 -17.9081 139.015 -29.9137 153.411 -42.6783C156.898 -45.7559 160.364 -48.854 163.933 -51.829C165.83 -53.3992 167.829 -54.9698 169.993 -56.0884C178.629 -60.542 188.37 -59.1981 194.938 -52.8027C201.342 -46.5714 203.403 -36.2308 199.976 -27.8046C197.665 -22.1391 194.02 -17.3123 188.691 -14.6396C181.912 -11.2623 176.469 -6.24399 170.697 -1.61537C160.295 6.71208 149.995 15.1832 139.675 23.6132C138.758 24.3776 137.594 25.0195 137.398 27.4271L137.398 27.4683Z" fill="#007CC2"/>
    </svg>
    <svg class="shape-2" :class="[{step1: currentStep === 1}, {step2: currentStep === 2}]" width="147" height="197" viewBox="0 0 147 197" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M69.6808 8.43687C69.2228 8.60014 68.8725 8.77701 68.5221 8.95388C63.551 11.0899 59.0536 17.2657 59.0536 17.2657L39.2163 43.6148L17.7897 72.101C13.5577 77.7274 12.5956 85.1646 15.2567 91.6827L46.3714 167.896L96.4283 102.248C99.9799 97.5003 107.177 93.3238 113.419 94.1121C113.526 94.1257 115.356 94.3567 118.584 94.7645L115.356 94.3567C108.899 93.5412 101.405 87.9515 98.8906 81.8852L71.9862 17.0196C71.826 16.5571 71.652 16.2035 71.5718 15.9723C71.4116 15.5098 71.3589 15.0609 71.1987 14.5985C71.146 14.1496 71.0934 13.7008 71.0407 13.2519L71.0545 13.1431C71.0957 12.8166 71.043 12.3677 71.1919 12.0549C71.2331 11.7284 71.2881 11.2932 71.4369 10.9803C71.4507 10.8715 71.572 10.7762 71.5858 10.6674C71.7209 10.4634 71.7484 10.2458 71.8835 10.0417C72.0048 9.9465 72.1399 9.74243 72.1537 9.6336C72.2888 9.42956 72.4239 9.22555 72.6666 9.0351C72.788 8.93987 72.9093 8.8446 73.0444 8.64056C73.1658 8.54534 73.2872 8.45013 73.4085 8.35491C73.7589 8.17803 74.1092 8.00118 74.4595 7.82432C74.6885 7.74269 74.9175 7.66107 75.2541 7.59301C75.4831 7.51138 75.5907 7.52494 75.8197 7.44331L75.9273 7.4569C76.3715 7.40245 76.9233 7.36161 77.4752 7.32075C74.5283 7.28022 71.863 7.60692 69.6808 8.43687Z" fill="#F6B09D"/>
      <path d="M77.0205 7.59378C77.3441 7.63464 77.6814 7.56698 78.1129 7.62147C77.5598 7.66188 77.0068 7.70228 76.5617 7.75632L76.4538 7.7427C76.2244 7.82398 76.1165 7.81037 75.8871 7.89165C75.6577 7.97294 75.3204 8.04058 75.0909 8.12186C74.7399 8.29805 74.3889 8.47424 74.0379 8.65043C73.9164 8.74533 73.7948 8.84022 73.6732 8.93513C73.5517 9.03003 73.4301 9.12496 73.2948 9.32839C73.1595 9.53182 72.9164 9.7216 72.7811 9.92503C72.6596 10.0199 72.5243 10.2234 72.5106 10.3319C72.3753 10.5353 72.24 10.7388 72.2126 10.9558C72.1989 11.0643 72.0774 11.1593 72.0636 11.2678C71.9147 11.5797 71.8735 11.9053 71.8187 12.3394C71.7776 12.665 71.7365 12.9906 71.6817 13.4247L71.6679 13.5332C71.721 13.9809 71.6662 14.415 71.8271 14.8764C71.8801 15.3241 72.041 15.7855 72.2019 16.2468C72.2823 16.4775 72.3491 16.8167 72.6179 17.2917L99.6209 82.005C102.144 88.057 109.55 93.6232 116.13 94.4541L119.366 94.8628L278.138 114.915C284.61 115.732 287.869 111.623 285.359 105.463L258.37 40.6407C255.847 34.5886 248.454 28.914 241.875 28.083L79.7582 7.60873C78.7737 7.59466 77.8971 7.59423 77.0205 7.59378Z" fill="#983628"/>
      <path d="M277.928 115.01C277.928 115.01 114.068 94.4259 113.433 94.2357C107.164 93.444 99.9421 97.5962 96.3808 102.321L46.1856 167.652L92.3349 173.481L112.638 176.077L198.791 187.092L233.025 191.469C233.025 191.469 283.438 125.284 283.736 124.661C283.736 124.661 288.098 117.946 285.966 107.879C286.768 112.824 283.548 115.72 277.928 115.01Z" fill="#FF4337"/>
    </svg>
    <svg class="shape-3" :class="[{step1: currentStep === 1}, {step2: currentStep === 2}]" width="352" height="324" viewBox="0 0 352 324" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M113.723 269.46C114.716 269.971 187.973 278.91 187.973 278.91C191.62 279.128 195.278 278.501 198.657 277.08C202.036 275.659 205.042 273.483 207.437 270.725L309.053 138.873C310.923 136.253 312.201 133.27 312.8 130.13C313.399 126.991 313.305 123.768 312.523 120.684C313.328 125.375 310.221 128.431 304.403 127.817L234.035 119.138C230.422 118.511 227.019 117.054 224.097 114.883C221.176 112.712 218.819 109.889 217.214 106.639L215.515 102.598L217.234 106.686C218.468 110.047 218.888 113.656 218.458 117.226C218.029 120.795 216.762 124.226 214.76 127.245L193.233 155.379L113.503 258.891L113.267 258.99C109.984 263.214 105.877 263.629 102.842 260.641C105.359 264.708 109.189 267.811 113.723 269.46Z" fill="#A18037"/>
      <path d="M76.6157 241.626L101.134 258.096C103.694 264.181 109.142 264.842 113.258 259.558L214.807 127.68C216.809 124.661 218.075 121.23 218.505 117.661C218.934 114.091 218.515 110.482 217.281 107.121L185.806 32.2793L156.477 70.4191L95.4719 148.358L43.7459 214.441L76.6157 241.626Z" fill="#FFE4B9"/>
      <path d="M203.289 34.0575L185.853 32.2596L217.328 107.101C218.932 110.351 221.29 113.174 224.211 115.345C227.132 117.516 230.536 118.973 234.149 119.6L304.516 128.278C311.144 129.1 314.502 124.79 311.923 118.657L284.534 53.5294C281.65 46.6721 275.216 41.9371 267.818 41.1529C250.987 39.3687 221.57 36.1392 202.911 34.2164" fill="#FCC157"/>
    </svg>
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" xl="10">
          <div class="box-return ml-2 ml-md-0">
            <div class="box-return box-return--point mb-0" @click="checkIfFormFilled">
              <img src="../../assets/media/icons/chevron-left-plain.svg" alt="Icon left" />
              <p>wróć</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  <section>
    <b-container v-if="!formSelected || formSelected === ''">
      <b-row>
        <b-col class="text-center" cols="12">
          <h1>Formularz rejestracyjny do programu Solve for Tomorrow</h1>
          <p class="mt-5">Zanim przejdziesz do formularza, zaznacz jaką pełnisz rolę:</p>
        </b-col>
      </b-row>
      <b-row class="form-type-buttons">
        <b-col md="12" lg="6" class="text-center mb-3">
          <b-button @click="formSelected = 'school'" variant="secondary">Nauczyciel/-ka szkoły podstawowej (klasy 7-8)</b-button>
        </b-col>
        <b-col md="12" lg="6" class="text-center mb-3">
          <b-button @click="formSelected = 'university'" variant="info">Nauczyciel/-ka szkoły ponadpodstawowej</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <a class="link-statute" href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf" target="_blank">Regulamin programu</a>
        </b-col>
      </b-row>
    </b-container>
    <form v-else @submit="this.nextStep">
      <b-container v-if="formSelected === 'school'">
        <b-row>
          <b-col class="form-head text-center" :class="currentStep >= 2 ? 'mb-7' : ''">
            <h3 class="form-title">Formularz zgłoszeniowy do 6. edycji programu Solve for Tomorrow</h3>
            <h6>Zgłoszenia przyjmujemy do 31 grudnia 2026 r., do godz. 23:59.</h6>
            <a v-if="!this.formSend && this.currentStep === 0" class="form-head__link ml-0 mt-3" href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf" target="_blank">Regulamin</a>
            <div class="form-head__box" v-if="currentStep < 2">
              <p>Formularz wypełnia opiekun/opiekunka zespołu <br /> (nauczyciel/nauczycielka, edukator/edukatorka za zgodą dyrektora placówki)</p>
            </div>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="12" lg="10">
            <b-row align-h="center">
              <b-col cols="12" xl="5" class="hr_container">
                <div class="number" v-if="currentStep === 0" :class="[{active: currentStep === 0},{finished: currentStep > 0}]">01</div>
                <div class="" v-if="currentStep > 0" :class="[{active: currentStep === 0},{finished: currentStep > 0}]">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="19" fill="#13588A"/>
                    <rect x="1" y="1" width="38" height="38" rx="19" stroke="#13588A" stroke-width="2"/>
                    <path d="M12 20.8824L16.5714 25L28 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="number-line"></div>
                <div class="number" v-if="currentStep < 2" :class="[{active: currentStep === 1},{finished: currentStep > 1}]">02</div>
                <div class="" v-if="currentStep >= 2" :class="[{active: currentStep === 2},{finished: currentStep > 2}]">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="19" fill="#13588A"/>
                    <rect x="1" y="1" width="38" height="38" rx="19" stroke="#13588A" stroke-width="2"/>
                    <path d="M12 20.8824L16.5714 25L28 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <div class="number-line"></div>
                <div class="number" v-if="currentStep < 2" :class="[{active: currentStep === 2},{finished: currentStep > 2}]">03</div>
                <div class="" v-if="currentStep >= 2" :class="[{active: currentStep === 2},{finished: currentStep > 2}]">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1" y="1" width="38" height="38" rx="19" fill="#13588A"/>
                    <rect x="1" y="1" width="38" height="38" rx="19" stroke="#13588A" stroke-width="2"/>
                    <path d="M12 20.8824L16.5714 25L28 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-3 text-center">
              <b-col class="number-text" :class="[{active: currentStep === 0},{finished: currentStep > 0}]" cols="3" xl="2">
                <p>Aplikacja</p>
              </b-col>
              <b-col class="number-text" :class="[{active: currentStep === 1},{finished: currentStep > 1}]" cols="3" xl="2">
                <p>Regulamin, zgody i oświadczenia</p>
              </b-col>
              <b-col class="number-text" :class="[{active: currentStep === 2},{finished: currentStep > 2}]" cols="3" xl="2">
                <p>Potwierdzenie</p>
              </b-col>
            </b-row>
            <b-row v-if="currentStep === 0">
              <b-col cols="12" class="form-content">
                <b-row align-h="center">
                  <b-col cols="10" xl="6">
                    <h4 class="form-section-title blue">Informacje o zespole</h4>
                    <div class="input-box">
                      <p>Pełna nazwa placówki wiodącej (Placówka wiodąca to ta, z którą związany jest opiekun lub opiekunka zespołu. Zespół może składać się z uczniów i uczennic z maksymalnie 3 szkół/placówek. Nie trzeba podawać danych pozostałych szkół.).</p>
                      <b-input required class="mb-4 input" placeholder="" v-model="schoolForm.school_name"></b-input>
                    </div>
                    <div class="input-box select-box">
                      <p>Adres placówki wiodącej, z której pochodzi zespół</p>
                      <b-select class="input select" required :options="voivodeships" v-model="schoolForm.school_voivodeship" @blur.native="onBlur" @change.native="onSelectChange" @click.native="toggleDropdown">
                        <template #first>
                          <b-select-option :value="null" class="select" disabled>Województwo</b-select-option>
                        </template>
                      </b-select>
                      <span class="select-icon" :class="{ 'rotate': isSelectFocused }"></span>
                    </div>
                    <div class="input-box">
                      <b-input class="input" required placeholder="Ulica" v-model="schoolForm.school_street"></b-input>
                    </div>
                    <b-row>
                      <b-col cols="12" lg="4">
                        <div class="input-box">
                          <b-input class="w-100 input" maxlength="6" required placeholder="Kod pocztowy" v-model="schoolForm.school_zip"  @input="formatZipCode"></b-input>
                          <span class="input-box-instruction">w formacie 11-222</span>
                        </div>
                      </b-col>
                      <b-col>
                        <div class="input-box">
                          <b-input class="w-100 input" required placeholder="Miejscowość" v-model="schoolForm.school_city"></b-input>
                        </div>
                      </b-col>
                    </b-row>
                    <div class="input-box">
                      <p>Liczba osób w zespole (wraz z opiekunem/opiekunką)</p>
                      <div class="d-flex justify-content-start">
                        <div class="radio-box d-flex flex-wrap justify-content-around">
                          <label v-for="teamSizeValue in [3,4,5]" :key="teamSizeValue" class="input-control">
                            <input type="radio" name="teamSize" :value="teamSizeValue" v-model="teamSize" required />
                            {{ teamSizeValue }} {{ teamSizeValue === 5 ? "osób" : "osoby" }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="input-box">
                      <p class="mb-3">Dane opiekuna/opiekunki zespołu</p>
                      <b-input class="input" required placeholder="Imię i nazwisko" v-model="schoolForm.first_name"></b-input>
                      <b-row>
                        <b-col>
                          <b-input class="mt-3 input" required placeholder="Adres email" v-model="schoolForm.email"></b-input>
                        </b-col>
                        <b-col>
                          <b-input class="mt-3 input" maxlength="11" required placeholder="Numer telefonu" v-model="schoolForm.phone" @input="formatPhone"></b-input>
                          <span class="input-box-instruction">w formacie 111 222 333</span>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="input-box">
                      <p class="mb-3">Dane lidera/liderki zespołu</p>
                      <b-input class="input" required placeholder="Imię i nazwisko" v-model="schoolForm.first_name_leader"></b-input>
                      <b-row>
                        <b-col>
                          <b-input class="mt-3 input" required placeholder="Adres email" v-model="schoolForm.email_leader"></b-input>
                        </b-col>
                        <b-col>
                          <b-input class="mt-3 input" maxlength="11" required placeholder="Numer telefonu" v-model="schoolForm.phone_leader" @input="formatPhoneLeader">></b-input>
                          <span class="input-box-instruction">w formacie 111 222 333</span>
                        </b-col>
                      </b-row>
                    </div>
                    <h5 class="star-box">Imiona i nazwiska wszystkich członków, członkiń zespołu (tylko uczniowie i uczennice)</h5>
                    <b-row class="d-flex" v-for="index in teamSize - 1" :key="index">
                      <b-col cols="8">
                        <b-input class="input mt-3" required placeholder="Imię i nazwisko" v-model="schoolForm.team_members[index - 1].firstname"></b-input>
                      </b-col>
                      <b-col cols="4">
                        <p class="star">*</p>
                        <b-input class="input mt-3 input-number-star" required type="number" min="1" max="100" placeholder="Wiek" v-model="schoolForm.team_members[index - 1].age"></b-input>
                      </b-col>
                      <b-col cols="12 mb-4">
                        <b-row class="px-2">
                          <label v-for="genderOption in ['kobieta', 'mężczyzna', 'inna', 'wolę nie podawać']" :key="genderOption + (index - 1)" class="input-control col-3" style="font-size: 0.75rem">
                            <input type="radio" :name="'gender' + (index - 1)" :value="genderOption" v-model="schoolForm.team_members[index - 1].gender" required />
                            {{ genderOption }}
                          </label>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="margin-16">
                      <b-col>
                        <p class="regular-text"><span class="star-red">*</span> Wiek w chwili wypełniania formularza</p>
                      </b-col>
                    </b-row>
                    <div class="input-box">
                      <p class="mb-3">Jeśli jesteś opiekunem/opiekunką zespołu w szkole, jakiego przedmiotu/jakich przedmiotów uczysz?</p>
                      <b-textarea class="input" rows="4" required placeholder="Przedmiot/Przedmioty" v-model="schoolForm.subjects"></b-textarea>
                    </div>
                    <div class="input-box select-box">
                      <p>Funkcja w szkole lub innej placówce opiekuna/opiekunki zespołu</p>
                      <b-select class="input select" required :options="teacherRoles" v-model="schoolForm.role" @blur.native="onBlur" @change.native="onSelectChange" @click.native="toggleDropdown"></b-select>
                      <span class="select-icon" :class="{ 'rotate': isSelectFocused }"></span>
                    </div>
                    <div v-if="schoolForm.role === 'Inne'">
                      <b-input class="input" placeholder="Wpisz swoją funkcję w szkole" required type="text" v-model="schoolForm.custom_role"></b-input>
                    </div>
                    <label class="input-control mb-2 align-items-start">
                      <input type="checkbox" class="mb-4 label" required v-model="schoolForm.parental_consent" />
                      <p class="regular-consent">Oświadczenie osoby wypełniającej formularz: Posiadam
                        zgody rodziców lub prawnych opiekunów dla wszystkich niepełnoletnich członków
                        i członkiń zespołu i w każdej chwili jestem gotowa/gotowy przekazać je
                        Organizatorowi Solve for Tomorrow. Wzór zgody znajduje się w <a target="_blank" href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf">regulaminie</a>. <span class="star-red">*</span></p>
                    </label>
<!--                    <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2023/09/zgoda_na_udzial_dziecka_w-programie_SFT_3_edycja.pdf" target="_blank">wzór zgody do pobrania.</a>-->
                    <label class="input-control mb-2 align-items-start">
                      <input type="checkbox" class="mb-4 label" required v-model="schoolForm.director_consent" />
                      <p class="regular-consent">Oświadczenie osoby wypełniającej formularz: Posiadam zgodę dyrektora placówki na udział zgłaszanego zespołu w programie Solve for Tomorrow. Wzór zgody znajduje się w <a target="_blank" href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf">regulaminie</a>. <span class="star-red">*</span></p>
                    </label>
<!--                    <a class="link" href="https://solvefortomorrow.pl/wp-content/uploads/2023/09/Zgoda_dyrektora_SFT_3_edycja.pdf" target="_blank">(wzór zgody do pobrania).</a>-->
                    <label class="input-control mb-2 align-items-start">
                      <input type="checkbox" class="mb-4 label" required v-model="schoolForm.team_regulation_consent" />
                      <p class="regular-consent">Oświadczenie osoby wypełniającej formularz: Posiadam zgody wszystkich
                        pełnoletnich członków i członkiń zespołu na
                        zgłoszenie ich do programu Solve for Tomorrow. Wzór zgody znajduje się w
                        <a target="_blank" href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf">regulaminie</a>. <span class="star-red">*</span></p>
                    </label>
                    <h5 class="star-box">Czy zgłaszałeś, zgłaszałaś udział zespołu do programu Solve for Tomorrow w poprzednich edycjach?</h5>
                    <b-form-checkbox-group>
<!--                      <label class="input-control mt-3 align-items-start">-->
<!--                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 1 edycji" class="label" v-model="schoolForm.editions" />-->
<!--                        <p class="regular-consent mt-1">Do 1. edycji</p>-->
<!--                      </label>-->
<!--                      <label class="input-control input-control&#45;&#45;small-margin align-items-start">-->
<!--                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 2 edycji" class="label" v-model="schoolForm.editions" />-->
<!--                        <p class="regular-consent mt-1">Do 2. edycji</p>-->
<!--                      </label>-->
<!--                      <label class="input-control input-control&#45;&#45;small-margin align-items-start">-->
<!--                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 3 edycji" class="label" v-model="schoolForm.editions" />-->
<!--                        <p class="regular-consent mt-1">Do 3. edycji</p>-->
<!--                      </label>-->
<!--                      <label class="input-control input-control&#45;&#45;small-margin align-items-start">-->
<!--                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Nie')" name="edition"  value="Do 4 edycji" class="label" v-model="schoolForm.editions" />-->
<!--                        <p class="regular-consent mt-1">Do 4. edycji</p>-->
<!--                      </label>-->
<!--                      <label class="input-control input-control&#45;&#45;small-margin align-items-start">-->
<!--                        <input type="checkbox" :disabled="this.schoolForm.editions.includes('Do 1 edycji') || this.schoolForm.editions.includes('Do 2 edycji') || this.schoolForm.editions.includes('Do 3 edycji')" name="edition" value="Nie" class="label" required v-model="schoolForm.editions" />-->
<!--                        <p class="regular-consent mt-1">Nie zgłaszałem/-am</p>-->
<!--                      </label>-->
                          <label class="input-control input-control--small-margin align-items-start">
                            <input type="checkbox" name="edition"  value="Tak" class="label" v-model="schoolForm.editions" />
                            <p class="regular-consent mt-1">Tak</p>
                          </label>
                          <label class="input-control input-control--small-margin align-items-start">
                            <input type="checkbox" name="edition" value="Nie" class="label" v-model="schoolForm.editions" />
                            <p class="regular-consent mt-1">Nie</p>
                          </label>
                    </b-form-checkbox-group>
                    <h5 class="star-box">W jaki sposób dowiedziałeś/dowiedziałaś się o programie Solve for Tomorrow?</h5>
                    <b-form-radio-group required>
                      <label v-for="howDoYouKnowOption in howDoYouKnowOptions" :key="howDoYouKnowOption" class="input-control mt-3 align-items-start">
                        <input type="radio" name="sft_find_out"  :value="howDoYouKnowOption" class="label" v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent">{{howDoYouKnowOption }}</p>
                      </label>
                      <div v-if="schoolForm.sft_find_out === 'Od Alumnów Solve for Tomorrow'">
                        <b-input class="mb-4 input" placeholder="Imię i nazwisko" required type="text" v-model="schoolForm.sft_find_out_diffrent"></b-input>
                      </div>
                      <label class="input-control input-control--small-margin">
                        <input type="radio" name="sft_find_out" value="Inne" required v-model="schoolForm.sft_find_out" />
                        <p class="regular-consent mt-1">Inne</p>
                      </label>
                    </b-form-radio-group>
                    <div v-if="schoolForm.sft_find_out === 'Inne'">
                      <b-input class="mb-4 input" placeholder="Wpisz skąd dowiedziałeś/dowiedziałaś o SFT" required type="text" v-model="schoolForm.sft_find_out_diffrent"></b-input>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" class="form-content mt-8">
                <b-row align-h="center">
                  <b-col cols="10" xl="6">
                    <h4 class="form-section-title form-section-title--small-margin red">Wyzwanie Solve for Tomorrow</h4>
                    <p class="regular-big-text text-center">
                      Opowiedz nam o wyzwaniu, które Twój zespół chce podjąć na rzecz społeczności lokalnej
                    </p>
                    <b-row>
                      <b-col cols="12 mt-6">
                        <h5 class="mt-0">W którym z obszarów zespół będzie realizował wyzwanie?</h5>
                        <b-row class="d-flex justify-content-around">
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 1" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 1 }">
                                <svg width="98" height="98" id="Warstwa_1" data-name="Warstwa 1" fill="black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                                  <path xmlns="http://www.w3.org/2000/svg" class="cls-1" d="M267.3,208.82h-20.01v-17.63h20.01c7.53,0,13.64-6.11,13.64-13.64v-44.85c0-7.53-6.11-13.64-13.64-13.64h-44.85c-7.49.02-13.62,6.15-13.64,13.65v20.01h-17.63v-20.02c0-7.53-6.11-13.64-13.64-13.64h-44.85c-7.49.02-13.62,6.15-13.64,13.65v44.84c.02,7.49,6.15,13.62,13.65,13.64h20.01v17.57h-20.02c-7.52.02-13.64,6.17-13.64,13.69v44.85c.02,7.49,6.15,13.62,13.65,13.64h44.84c7.53,0,13.64-6.11,13.64-13.64v-20.01h17.58v20.01c.02,7.49,6.15,13.62,13.65,13.64h44.89c7.53,0,13.64-6.11,13.64-13.64v-44.85c0-7.53-6.11-13.64-13.64-13.64h0ZM276.11,267.31c.02,2.31-.87,4.52-2.51,6.19s-3.83,2.6-6.17,2.63h-44.99c-4.87,0-8.81-3.95-8.81-8.81v-20.01h25.62c1.33,0,2.41-1.08,2.41-2.41h0c0-1.33-1.08-2.41-2.41-2.41h-48.07v-20.01c0-7.53-6.11-13.64-13.64-13.64h0c-1.32,0-2.38,1.07-2.38,2.38v.03c0,1.33,1.08,2.41,2.41,2.41h.11c2.28,0,4.45.89,6.1,2.51,1.67,1.64,2.6,3.83,2.62,6.17v44.99c.02,2.31-.87,4.52-2.51,6.19s-3.83,2.6-6.17,2.63h-45.03c-4.87,0-8.81-3.95-8.81-8.81v-44.85c0-4.87,3.95-8.81,8.81-8.81h20.01v25.61c0,1.33,1.08,2.41,2.41,2.41h0c1.33,0,2.41-1.08,2.41-2.41v-48.07h20.01c7.53,0,13.64-6.11,13.64-13.64h0c0-1.32-1.07-2.39-2.39-2.39h-.05c-1.32,0-2.39,1.07-2.39,2.39v.05c.02,2.31-.87,4.52-2.51,6.19s-3.83,2.6-6.17,2.63h-44.97c-4.87,0-8.81-3.95-8.81-8.81v-44.94c0-4.87,3.95-8.81,8.81-8.81h44.85c2.27.02,4.52.87,6.19,2.51s2.6,3.83,2.62,6.17v20.15h-25.61c-1.33,0-2.41,1.08-2.41,2.41h0c0,1.33,1.08,2.41,2.41,2.41h48.07v20.01c.03,10.82,8.86,13.1,13.41,13.55,1.43.14,2.66-.96,2.66-2.39h0c0-1.25-.94-2.28-2.18-2.39-3.27-.31-9.07-1.83-9.07-8.76v-44.86c0-4.87,3.95-8.81,8.81-8.81h44.93c4.76,0,8.68,3.88,8.73,8.68v44.99c.02,2.31-.87,4.52-2.51,6.19s-3.83,2.6-6.17,2.63h-20.15v-25.61c0-1.33-1.08-2.41-2.41-2.41h0c-1.33,0-2.41,1.08-2.41,2.41v48.07h-20.01c-7.49.02-13.62,6.15-13.64,13.65h0c0,1.33,1.08,2.41,2.41,2.4h.02c1.32,0,2.39-1.08,2.39-2.4h0c0-4.88,3.95-8.82,8.81-8.82h44.94c2.28,0,4.45.89,6.1,2.51,1.67,1.64,2.6,3.83,2.62,6.17v44.99l.02-.03Z"/>                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Integracja" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                <small>Integracja</small>
                              </div>
                            </label>
                          </div>
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 2" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 2 }">
                                <svg width="98" height="98" id="Warstwa_1" data-name="Warstwa 1" fill="black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                                  <path d="M204.85,303.51h-21.03c-7.54,0-13.67-6.13-13.67-13.67v-2.15c0-3.09-1.94-5.81-4.94-6.93-1.94-.72-3.89-1.53-5.8-2.41-2.92-1.34-6.22-.79-8.41,1.4l-1.52,1.52c-5.33,5.33-14,5.33-19.34,0l-14.87-14.87c-5.33-5.33-5.33-14,0-19.33l1.52-1.52c2.19-2.19,2.74-5.49,1.4-8.41-.87-1.9-1.68-3.85-2.41-5.8-1.11-3-3.83-4.94-6.93-4.94h-2.15c-7.54,0-13.67-6.13-13.67-13.67v-21.03c0-7.54,6.13-13.67,13.67-13.67h2.15c3.09,0,5.81-1.94,6.93-4.94.72-1.95,1.53-3.9,2.41-5.8,1.34-2.92.79-6.22-1.4-8.41l-1.52-1.52c-2.58-2.58-4-6.02-4-9.67s1.42-7.09,4-9.67l14.87-14.87c5.33-5.33,14-5.33,19.34,0l1.52,1.52c2.19,2.2,5.49,2.74,8.41,1.4,1.91-.88,3.86-1.69,5.8-2.41,3-1.11,4.94-3.83,4.94-6.93v-2.15c0-7.54,6.13-13.67,13.67-13.67h21.03c7.54,0,13.67,6.13,13.67,13.67v2.15c0,3.09,1.94,5.81,4.94,6.93,1.94.72,3.89,1.53,5.8,2.41,2.92,1.34,6.22.79,8.41-1.4l1.52-1.52c5.33-5.33,14-5.33,19.34,0l14.87,14.87c2.58,2.58,4,6.02,4,9.67s-1.42,7.08-4,9.67l-1.52,1.52c-2.19,2.19-2.74,5.49-1.4,8.41.87,1.9,1.68,3.85,2.41,5.8,1.11,3,3.83,4.94,6.93,4.94h2.15c7.54,0,13.67,6.13,13.67,13.67v21.03c0,7.54-6.13,13.67-13.67,13.67h-2.15c-3.09,0-5.81,1.94-6.93,4.94-.73,1.95-1.54,3.9-2.41,5.8-1.34,2.92-.79,6.22,1.4,8.41l1.52,1.52c5.33,5.33,5.33,14.01,0,19.34l-14.87,14.87c-5.33,5.33-14,5.33-19.34,0l-1.52-1.52c-2.19-2.2-5.49-2.74-8.41-1.4-1.91.88-3.86,1.69-5.8,2.41-3,1.11-4.94,3.83-4.94,6.93v2.15c0,7.54-6.13,13.67-13.67,13.67ZM156.2,271.34c1.98,0,3.97.42,5.85,1.28,1.77.81,3.57,1.56,5.36,2.22,5.42,2.01,9.05,7.18,9.05,12.85v2.15c0,4.06,3.3,7.36,7.36,7.36h21.03c4.06,0,7.36-3.3,7.36-7.36v-2.15c0-5.67,3.64-10.84,9.05-12.85,1.79-.67,3.6-1.41,5.36-2.22,5.26-2.42,11.5-1.35,15.51,2.67l1.52,1.52c2.87,2.87,7.54,2.87,10.41,0l14.87-14.87c2.87-2.87,2.87-7.54,0-10.41l-1.52-1.52c-4.02-4.02-5.09-10.25-2.67-15.51.81-1.75,1.56-3.56,2.23-5.36,2.01-5.42,7.17-9.06,12.85-9.06h2.15c4.06,0,7.36-3.3,7.36-7.36v-21.03c0-4.06-3.3-7.36-7.36-7.36h-2.15c-5.67,0-10.84-3.64-12.85-9.06-.67-1.8-1.42-3.61-2.23-5.36-2.42-5.26-1.35-11.5,2.67-15.51l1.52-1.52c1.39-1.39,2.15-3.24,2.15-5.2s-.77-3.81-2.15-5.2l-14.87-14.87c-2.87-2.87-7.54-2.87-10.41,0l-1.52,1.52c-4.02,4.02-10.25,5.09-15.51,2.67-1.76-.81-3.57-1.56-5.36-2.22-5.42-2.01-9.06-7.18-9.06-12.85v-2.15c0-4.06-3.3-7.36-7.36-7.36h-21.03c-4.06,0-7.36,3.3-7.36,7.36v2.15c0,5.67-3.64,10.84-9.05,12.85-1.79.67-3.6,1.41-5.36,2.22-5.26,2.42-11.5,1.35-15.51-2.67l-1.52-1.52c-2.87-2.87-7.54-2.87-10.41,0l-14.87,14.87c-2.87,2.87-2.87,7.54,0,10.41l1.52,1.52c4.02,4.02,5.09,10.25,2.67,15.51-.81,1.75-1.56,3.56-2.22,5.36-2.01,5.42-7.18,9.06-12.85,9.06h-2.15c-4.06,0-7.36,3.3-7.36,7.36v21.03c0,4.06,3.3,7.36,7.36,7.36h2.15c5.67,0,10.84,3.64,12.85,9.05.67,1.81,1.42,3.61,2.23,5.36,2.42,5.26,1.35,11.5-2.67,15.51l-1.52,1.52c-2.87,2.87-2.87,7.54,0,10.4l14.87,14.87c2.87,2.87,7.54,2.87,10.41,0l1.52-1.52c2.59-2.59,6.09-3.95,9.66-3.95Z"/>
                                  <path d="M194.33,261.06c-32.84,0-59.56-26.72-59.56-59.56s26.72-59.56,59.56-59.56,59.56,26.72,59.56,59.56-26.72,59.56-59.56,59.56ZM194.33,147.2c-29.94,0-54.3,24.36-54.3,54.3s24.36,54.3,54.3,54.3,54.3-24.36,54.3-54.3-24.36-54.3-54.3-54.3Z"/>
                                  <path d="M155.42,245.68c-.23,0-.46-.03-.7-.09-1.4-.38-2.23-1.83-1.84-3.23,10.69-39.16,37.91-71.47,74.69-88.65,1.32-.61,2.88-.05,3.5,1.27.61,1.32.05,2.88-1.27,3.5-35.37,16.53-61.55,47.61-71.84,85.27-.32,1.17-1.38,1.94-2.54,1.94Z"/>
                                  <path d="M241.41,236.15c-.05,0-.1,0-.15,0-1.45-.08-2.56-1.33-2.48-2.78,1.21-20.95-6.87-41.21-22.16-55.59s-36.02-21.19-56.85-18.67c-1.44.17-2.75-.86-2.93-2.3s.86-2.75,2.3-2.93c22.39-2.69,44.65,4.62,61.09,20.06,16.43,15.44,25.11,37.21,23.81,59.73-.08,1.4-1.24,2.48-2.62,2.48Z"/>
                                  <path d="M194.33,261.06c-.78,0-1.55-.34-2.07-1.01-.9-1.14-.7-2.8.45-3.69,20.44-16.02,18.85-37.14,17.57-54.11-.9-11.94-1.68-22.25,5.77-27.43,10.44-7.28,23.89-.82,36.88,17.7.83,1.19.55,2.83-.64,3.67-1.19.84-2.83.55-3.66-.64-11.08-15.8-21.86-21.78-29.57-16.4-4.98,3.47-4.34,11.96-3.53,22.72,1.3,17.26,3.08,40.9-19.57,58.65-.48.38-1.05.56-1.62.56Z"/>
                                  <path d="M139.5,188.75c-.71,0-1.41-.28-1.93-.84-.99-1.06-.93-2.73.13-3.72,12.73-11.84,27.28-14.04,38.98-15.8,8.69-1.31,15.55-2.34,18.21-6.86,2.35-3.98-.37-10.07-2.77-15.45l-.2-.45c-.59-1.33,0-2.88,1.33-3.47,1.33-.59,2.88,0,3.47,1.33l.2.45c2.77,6.22,6.22,13.96,2.5,20.27-3.94,6.67-12.29,7.93-21.96,9.39-10.98,1.65-24.64,3.71-36.18,14.45-.51.47-1.15.71-1.79.71Z"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Sport i technologia" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                <small>Sport<br>i technologia</small>
                              </div>
                            </label>
                          </div>
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 3" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 3 }">
                                <svg width="98" height="98" id="Warstwa_1" fill="black" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                                  <g>
                                    <g>
                                      <path d="M254.28,147.96h-33.85c-10.54,0-25.2,12.35-25.2,23.14v87.23h4.07v-85.19c0-10.08,11.73-21.11,21.64-21.11h29.27c-.02,3.15-.05,6.77-.56,9.86-3.35,20.45-26.5,30.7-44.5,21.22l-2.27,3.25c17.66,10.33,41.71,2,49.11-17.05.68-1.74,2.3-6.78,2.3-8.38v-12.97ZM190.14,258.33v-66.88c0-9.24-10.3-19.58-19.6-19.58h-27.23v9.41c0,3.21,3.06,9.62,5.1,12.19,8.21,10.34,23.38,12.66,35.11,7.38l-2.28-3.43c-15.88,7.53-35.11-3.17-33.86-21.49h24.69c4.27,0,13.49,8.04,13.49,12.46v69.93h4.58Z"/>
                                      <path d="M199.31,258.85h-4.07c-.29,0-.53-.24-.53-.53v-87.23c0-9.78,13.3-23.67,25.72-23.67h33.85c.29,0,.53.24.53.53v12.97c0,1.78-1.77,7.12-2.33,8.57-3.58,9.2-11.22,16.43-20.98,19.83-9.79,3.41-20.32,2.49-28.88-2.52-.13-.07-.22-.2-.25-.34-.03-.14,0-.29.08-.41l2.27-3.25c.15-.22.44-.29.68-.16,8.68,4.57,19.15,4.66,28.01.25,8.49-4.23,14.22-11.91,15.73-21.09.46-2.79.53-5.96.55-9.25h-28.74c-9.86,0-21.11,10.96-21.11,20.58v85.19c0,.29-.24.53-.53.53ZM195.76,257.8h3.02v-84.67c0-10.11,11.81-21.63,22.16-21.63h29.27c.14,0,.27.06.37.15.1.1.15.23.15.38-.02,3.52-.07,6.93-.57,9.95-1.56,9.52-7.5,17.49-16.29,21.86-9.03,4.49-19.66,4.47-28.56-.05l-1.68,2.4c8.21,4.61,18.2,5.4,27.51,2.15,9.46-3.3,16.88-10.3,20.34-19.22.69-1.78,2.26-6.73,2.26-8.19v-12.44h-33.33c-9.97,0-24.67,11.91-24.67,22.62v86.7ZM190.14,258.85h-4.58c-.29,0-.53-.24-.53-.53v-69.94c0-4.23-9.09-11.93-12.96-11.93h-24.19c-.37,7.7,2.99,14.53,9.28,18.81,6.94,4.72,16.08,5.36,23.86,1.67.24-.11.52-.03.66.18l2.28,3.43c.09.13.11.29.07.44s-.15.27-.29.34c-12.7,5.71-27.73,2.55-35.74-7.53-2.05-2.58-5.22-9.13-5.22-12.52v-9.41c0-.29.24-.53.53-.53h27.23c9.59,0,20.12,10.52,20.12,20.11v66.88c0,.29-.24.53-.53.53ZM186.09,257.8h3.53v-66.36c0-8.9-10.16-19.06-19.07-19.06h-26.71v8.88c0,3.08,3.02,9.39,4.99,11.87,7.59,9.56,21.77,12.66,33.91,7.48l-1.68-2.53c-8.03,3.63-17.37,2.9-24.49-1.95-6.73-4.58-10.27-11.96-9.71-20.24.02-.28.25-.49.53-.49h24.69c4.46,0,14.02,8.15,14.02,12.99v69.41Z"/>
                                    </g>
                                    <g>
                                      <path d="M254.28,147.96v12.97c0,1.6-1.62,6.64-2.3,8.38-7.4,19.05-31.45,27.38-49.11,17.05l2.27-3.25c18,9.48,41.15-.77,44.5-21.22.51-3.1.55-6.71.56-9.86h-29.27c-9.9,0-21.64,11.03-21.64,21.11v85.19h-4.07v-87.23c0-10.79,14.65-23.14,25.2-23.14h33.85Z"/>
                                      <path d="M199.31,258.85h-4.07c-.29,0-.53-.24-.53-.53v-87.23c0-9.78,13.3-23.67,25.72-23.67h33.85c.29,0,.53.24.53.53v12.97c0,1.78-1.77,7.12-2.33,8.57-3.58,9.2-11.22,16.43-20.98,19.83-9.79,3.41-20.32,2.49-28.88-2.52-.13-.07-.22-.2-.25-.34-.03-.14,0-.29.08-.41l2.27-3.25c.15-.22.44-.29.68-.16,8.68,4.57,19.15,4.66,28.01.25,8.49-4.23,14.22-11.91,15.73-21.09.46-2.79.53-5.96.55-9.25h-28.74c-9.86,0-21.11,10.96-21.11,20.58v85.19c0,.29-.24.53-.53.53ZM195.76,257.8h3.02v-84.67c0-10.11,11.81-21.63,22.16-21.63h29.27c.14,0,.27.06.37.15.1.1.15.23.15.38-.02,3.52-.07,6.93-.57,9.95-1.56,9.52-7.5,17.49-16.29,21.86-9.03,4.49-19.66,4.47-28.56-.05l-1.68,2.4c8.21,4.61,18.2,5.4,27.51,2.15,9.46-3.3,16.88-10.3,20.34-19.22.69-1.78,2.26-6.73,2.26-8.19v-12.44h-33.33c-9.97,0-24.67,11.91-24.67,22.62v86.7Z"/>
                                    </g>
                                    <g>
                                      <path d="M190.14,258.33h-4.58v-69.93c0-4.42-9.22-12.46-13.49-12.46h-24.69c-1.25,18.31,17.98,29.02,33.86,21.49l2.28,3.43c-11.73,5.28-26.9,2.96-35.11-7.38-2.05-2.58-5.1-8.98-5.1-12.19v-9.41h27.23c9.3,0,19.6,10.34,19.6,19.58v66.88Z"/>
                                      <path d="M190.14,258.85h-4.58c-.29,0-.53-.24-.53-.53v-69.94c0-4.23-9.09-11.93-12.96-11.93h-24.19c-.37,7.7,2.99,14.53,9.28,18.81,6.94,4.72,16.08,5.36,23.86,1.67.24-.11.52-.03.66.18l2.28,3.43c.09.13.11.29.07.44s-.15.27-.29.34c-12.7,5.71-27.73,2.55-35.74-7.53-2.05-2.58-5.22-9.13-5.22-12.52v-9.41c0-.29.24-.53.53-.53h27.23c9.59,0,20.12,10.52,20.12,20.11v66.88c0,.29-.24.53-.53.53ZM186.09,257.8h3.53v-66.36c0-8.9-10.16-19.06-19.07-19.06h-26.71v8.88c0,3.08,3.02,9.39,4.99,11.87,7.59,9.56,21.77,12.66,33.91,7.48l-1.68-2.53c-8.03,3.63-17.37,2.9-24.49-1.95-6.73-4.58-10.27-11.96-9.71-20.24.02-.28.25-.49.53-.49h24.69c4.46,0,14.02,8.15,14.02,12.99v69.41Z"/>
                                    </g>
                                  </g>
                                  <path class="cls-1" d="M209.31,300.56h-21.03c-7.54,0-13.67-6.13-13.67-13.67v-2.15c0-3.09-1.94-5.81-4.94-6.93-1.94-.72-3.9-1.53-5.8-2.41-2.91-1.34-6.22-.79-8.41,1.4l-1.52,1.52c-2.58,2.58-6.02,4.01-9.67,4.01s-7.09-1.42-9.67-4.01l-14.87-14.87c-5.33-5.33-5.33-14.01,0-19.34l1.52-1.52c2.19-2.19,2.74-5.49,1.4-8.41-.88-1.91-1.69-3.86-2.41-5.8-1.11-3-3.83-4.94-6.93-4.94h-2.15c-7.54,0-13.67-6.13-13.67-13.67v-21.03c0-7.54,6.13-13.67,13.67-13.67h2.15c3.09,0,5.81-1.94,6.93-4.94.72-1.95,1.53-3.9,2.41-5.8,1.34-2.92.79-6.22-1.4-8.41l-1.52-1.52c-5.33-5.33-5.33-14.01,0-19.34l14.87-14.87c5.33-5.33,14-5.33,19.34,0l1.52,1.52c2.19,2.19,5.49,2.74,8.41,1.4,1.91-.88,3.86-1.69,5.8-2.41,3-1.11,4.94-3.83,4.94-6.93v-2.15c0-7.54,6.13-13.67,13.67-13.67h21.03c7.54,0,13.67,6.13,13.67,13.67v2.15c0,3.09,1.94,5.81,4.94,6.93,1.95.72,3.9,1.53,5.8,2.41,2.91,1.34,6.22.79,8.41-1.4l1.52-1.52c5.33-5.33,14-5.33,19.34,0l14.87,14.87c5.33,5.33,5.33,14,0,19.34l-1.52,1.52c-2.19,2.19-2.74,5.49-1.4,8.41.88,1.9,1.69,3.86,2.41,5.8,1.11,3,3.83,4.94,6.93,4.94h2.15c7.54,0,13.67,6.13,13.67,13.67v21.03c0,7.54-6.13,13.67-13.67,13.67h-2.15c-3.09,0-5.81,1.94-6.93,4.94-.72,1.94-1.53,3.9-2.41,5.8-1.34,2.92-.79,6.21,1.4,8.41l1.52,1.52c5.33,5.33,5.33,14.01,0,19.34l-14.87,14.87c-2.58,2.58-6.02,4-9.67,4s-7.09-1.42-9.67-4.01l-1.52-1.52c-2.19-2.19-5.49-2.74-8.41-1.4-1.91.88-3.86,1.69-5.8,2.41-3,1.11-4.94,3.83-4.94,6.93v2.15c0,7.54-6.13,13.67-13.67,13.67ZM160.66,268.39c1.98,0,3.98.42,5.85,1.28,1.76.81,3.57,1.56,5.36,2.22,5.42,2.01,9.06,7.18,9.06,12.85v2.15c0,4.06,3.3,7.36,7.36,7.36h21.03c4.06,0,7.36-3.3,7.36-7.36v-2.15c0-5.67,3.64-10.84,9.06-12.85,1.8-.67,3.6-1.42,5.36-2.22,5.26-2.42,11.5-1.35,15.51,2.67l1.52,1.52c2.78,2.78,7.63,2.78,10.4,0l14.87-14.87c1.39-1.39,2.15-3.24,2.15-5.2s-.77-3.81-2.16-5.2l-1.52-1.52c-4.02-4.02-5.09-10.25-2.67-15.51.81-1.76,1.56-3.57,2.22-5.36,2.01-5.42,7.17-9.06,12.85-9.06h2.15c4.06,0,7.36-3.3,7.36-7.36v-21.03c0-4.06-3.3-7.36-7.36-7.36h-2.15c-5.67,0-10.84-3.64-12.85-9.06-.67-1.8-1.42-3.6-2.22-5.36-2.42-5.26-1.35-11.5,2.67-15.51l1.52-1.52c2.87-2.87,2.87-7.54,0-10.41l-14.87-14.87c-2.87-2.87-7.54-2.87-10.41,0l-1.52,1.52c-4.01,4.02-10.25,5.1-15.51,2.67-1.76-.81-3.56-1.56-5.36-2.22-5.42-2.01-9.06-7.17-9.06-12.85v-2.15c0-4.06-3.3-7.36-7.36-7.36h-21.03c-4.06,0-7.36,3.3-7.36,7.36v2.15c0,5.67-3.64,10.84-9.06,12.85-1.8.67-3.6,1.41-5.36,2.22-5.26,2.42-11.5,1.35-15.51-2.67l-1.52-1.52c-2.87-2.87-7.54-2.87-10.4,0l-14.87,14.87c-2.87,2.87-2.87,7.54,0,10.41l1.52,1.52c4.02,4.02,5.09,10.25,2.67,15.51-.81,1.76-1.56,3.57-2.22,5.36-2.01,5.42-7.17,9.06-12.85,9.06h-2.15c-4.06,0-7.36,3.3-7.36,7.36v21.03c0,4.06,3.3,7.36,7.36,7.36h2.15c5.67,0,10.84,3.64,12.85,9.06.67,1.8,1.41,3.6,2.22,5.36,2.42,5.26,1.35,11.49-2.67,15.51l-1.52,1.52c-1.39,1.39-2.16,3.24-2.16,5.2s.77,3.81,2.16,5.2l14.87,14.87c2.78,2.78,7.62,2.78,10.41,0l1.52-1.52c2.59-2.59,6.09-3.95,9.66-3.95Z"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Zrównoważone środowisko i technologia" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                <small>Zrównoważone<br>środowisko<br>i technologia</small>
                              </div>
                            </label>
                          </div>
                          <div class="radio-box mt-3">
                            <label @click="activeIndex = 4" class="col text-center box input-control mt-0 img">
                              <div :class="{ active: activeIndex === 4 }">
                                <svg width="98" height="98" id="Warstwa_1" fill="black" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
                                  <path class="st0" d="M269.47,139.86c-22.92-4.42-45.12-11.98-65.99-22.47-2.11-1.06-4.52-1.09-6.6-.08-19.8,9.53-56.21,19.53-66.89,22.37h0c-3.29.88-5.58,3.87-5.58,7.27v42.88c0,60.84,55.84,86.65,72.96,93.11.85.32,1.74.48,2.64.48s1.79-.16,2.64-.48c17.12-6.45,72.96-32.24,72.96-93.11v-42.59c0-3.59-2.57-6.69-6.12-7.38ZM270.66,189.83c0,57.7-53.4,82.32-69.76,88.49-.58.22-1.21.22-1.79,0-16.37-6.18-69.76-30.82-69.76-88.49v-42.88c0-1.17.79-2.19,1.91-2.49,10.79-2.87,47.58-12.98,67.77-22.7.7-.34,1.51-.32,2.23.04,21.27,10.7,43.91,18.41,67.27,22.91,1.23.24,2.12,1.3,2.12,2.53v42.59Z"/>
                                  <path class="st0" d="M226.34,187.59c-1.31-.37-2.63-.71-3.96-1.02-.75-.18-1.5-.32-2.25-.48v-11.21c0-2.66-.29-5.32-1.25-7.82-.69-1.79-1.55-3.47-2.71-5-1.25-1.64-2.64-3.02-4.29-4.27-6.21-4.69-14.98-5.1-21.72-1.35-3.26,1.81-6.03,4.59-7.82,7.86-1.65,3.02-2.5,6.41-2.5,9.85v11.93c-2.19.46-4.37.99-6.52,1.6-.16.04-.31.11-.45.18-2.32.91-3.89,3.1-3.93,5.64v35.44c.03,2.78,1.89,5.09,4.54,5.85,5.41,1.55,10.97,2.57,16.57,3.16,5.41.57,10.86.67,16.29.31,5.58-.38,11.14-1.22,16.57-2.53,1.28-.31,2.59-.61,3.84-1.02,1.45-.47,2.71-1.42,3.47-2.75.59-1.02.81-2.15.81-3.31v-33.55c0-1.73.05-3.46-1.02-4.97-.92-1.3-2.14-2.11-3.67-2.54ZM184.76,174.75c0-.96.03-1.9.14-2.84.21-1.28.55-2.53,1.02-3.72.43-.96.92-1.89,1.51-2.76.14-.2.28-.4.43-.6.07-.09.15-.18.22-.27.36-.44.75-.86,1.15-1.27.4-.4.83-.79,1.27-1.15.03-.03.08-.07.13-.12.01,0,.02-.01.04-.03.23-.17.46-.34.7-.5.88-.59,1.81-1.09,2.77-1.51,1.22-.48,2.48-.82,3.77-1.03,1.39-.16,2.79-.16,4.18,0,1.29.2,2.56.55,3.79,1.03.96.43,1.89.92,2.76,1.51.2.14.4.28.59.42.09.08.18.15.28.23.44.36.86.75,1.27,1.15.4.4.79.83,1.15,1.27.03.03.07.08.12.13,0,.01.01.02.03.04.17.23.34.46.5.7.59.88,1.09,1.81,1.51,2.77.47,1.21.82,2.46,1.02,3.73.2,1.77.14,3.58.14,5.36v7.9c-.28-.04-.57-.1-.85-.14-5.55-.82-11.16-1.2-16.77-1.06-4.3.11-8.6.51-12.86,1.19v-10.42ZM226.12,224.69c0,1.4.01,2.81,0,4.21,0,.06,0,.12-.01.19-.02.09-.05.19-.08.28-.04.07-.07.15-.12.22-.05.05-.09.11-.12.15-.03.03-.06.05-.08.08-.11.07-.22.13-.34.19-.9.32-1.87.52-2.79.76-1.17.3-2.35.57-3.53.82-2.23.48-4.5.86-6.76,1.18-6.41.84-12.9,1.03-19.34.54-1.76-.13-3.53-.31-5.27-.55-2.27-.31-4.52-.7-6.75-1.17-1.15-.25-2.31-.51-3.45-.8-.95-.24-1.95-.44-2.88-.78-.1-.05-.19-.1-.29-.16-.05-.04-.11-.08-.14-.11-.03-.03-.06-.06-.08-.09-.06-.09-.1-.18-.15-.28-.03-.09-.05-.17-.07-.26-.02-.34-.01-.68-.01-1.02v-30.36c0-1.4-.01-2.8,0-4.21,0-.06,0-.12.01-.19.02-.09.05-.19.08-.28.04-.07.07-.15.12-.22.05-.05.09-.11.12-.15.03-.03.06-.05.08-.08.11-.07.23-.13.35-.19,0,0,.01,0,.02,0h0c4.27-1.22,8.63-2.13,13.04-2.74,6.42-.84,12.91-1.03,19.35-.55,1.76.13,3.53.31,5.27.55,2.27.31,4.52.7,6.75,1.17,1.15.25,2.31.51,3.45.8.95.24,1.95.44,2.88.78.1.05.19.1.29.16.05.04.11.08.14.11.03.03.06.06.08.09.06.09.1.18.15.28.03.09.05.17.07.26.02.34.01.68.01,1.02v30.36Z"/>
                                  <path class="st0" d="M206.12,202.9c-.97-1.35-2.18-2.28-3.73-2.87-2.7-1.02-6.11-.1-7.95,2.12-1.08,1.29-1.67,2.74-1.82,4.42-.13,1.43.27,2.99,1.01,4.22.71,1.2,1.81,2.26,3.08,2.85.21.1.42.16.63.24v7.73c0,1.39,1.22,2.72,2.66,2.66,1.44-.07,2.66-1.17,2.66-2.66v-7.66c2.8-1.05,4.7-3.93,4.74-6.91,0-.16-.01-.32-.05-.48-.09-1.29-.47-2.61-1.22-3.65ZM202.48,207.03c0,.11-.02.22-.02.33-.04.21-.1.42-.17.62-.09.17-.17.35-.28.51-.03.05-.06.09-.09.14-.07.07-.15.14-.16.15-.06.06-.13.12-.2.19-.02.01-.03.02-.05.03-.18.12-.38.22-.58.32-.19.06-.38.11-.57.15-.24.02-.48.02-.71,0-.2-.04-.41-.1-.61-.16-.17-.09-.35-.17-.51-.28-.05-.03-.1-.07-.15-.1-.07-.07-.14-.14-.15-.15-.07-.07-.14-.15-.21-.22,0,0,0-.01-.01-.02-.12-.18-.22-.38-.32-.58-.06-.19-.11-.38-.15-.57-.02-.24-.02-.48,0-.71.04-.2.1-.41.16-.6.09-.17.17-.35.28-.51.03-.05.06-.09.09-.14.07-.07.15-.14.16-.15.08-.08.16-.15.24-.22,0,0,0,0,.01,0,.18-.12.38-.22.58-.32.19-.06.38-.11.57-.15.24-.02.47-.02.71,0,.21.04.41.1.6.16.17.09.35.17.51.28.05.03.1.07.15.1.07.07.14.14.15.15.07.07.14.15.21.22,0,0,0,.01.01.02.12.18.22.38.32.58.06.19.12.39.16.59,0,.11.02.23.03.35,0,0,0,0,0,.01h0Z"/>
                                </svg>
                              </div>
                              <div class="radio-box-2">
                                <input type="radio" class="" value="Bezpieczeństwo" name="topic" required v-model="schoolForm.team_subject_challenge" />
                                <small>Bezpieczeństwo</small>
                              </div>
                            </label>
                          </div>
                        </b-row>
                        <!--                        <h5 class="">Jakie wyzwania zidentyfikowaliście? Opiszcie problem, który zaobserwowaliście w swoim otoczeniu (np. w szkole, wśród społeczności lokalnej, w swojej miejscowości).</h5>-->
                        <h5 class="">Jaki problem chcecie rozwiązać i kogo on dotyczy? Opiszcie, co zauważyliście w swoim otoczeniu, komu chcecie pomóc i jakie potrzeby dostrzegacie.</h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea required rows="6" v-model="schoolForm.team_challenges"></b-textarea>
<!--                            <p>Opisz Wasze wyzwania</p>-->
                          </div>
                          <small class="maxlength-label">{{getWordsLeft(schoolForm.team_challenges, 200, 'team_challenges')}}</small>
                        </label>
<!--                        <small class="maxlength-label">Opiszcie problem, który zaobserwowaliście w swoim otoczeniu (np. w szkole, wśród społeczności lokalnej, w swojej miejscowości).</small>-->
<!--                        <h5 class="">Opowiedzcie o Waszym pomyśle na rozwiązanie problemu opisanego powyżej. Na czym on polega i co może zmienić. Jaki byłby pozytywny wpływ rozwiązania, które proponujecie w perspektywie krótko- i długoterminowej?</h5>-->
                        <h5 class="">Na czym polega Wasz pomysł i jak wykorzystacie technologię? Wyjaśnijcie, jak rozwiązanie ma działać, jaką rolę odegra w nim technologia i co zmieni się dzięki niemu na lepsze. Jeśli znacie podobne rozwiązania, napiszcie, co odróżnia Wasz pomysł. </h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea required rows="3" v-model="schoolForm.team_idea_short_description"></b-textarea>
<!--                            <p>Przedstaw pomysł</p>-->
                            <small class="maxlength-label">{{getWordsLeft(schoolForm.team_idea_short_description, 300, 'team_idea_short_description')}}</small>
                          </div>
                        </label>
<!--                        <h5 class="">-->
<!--                          Kogo dotyczy proponowane przez Wasz zespół rozwiązanie? Opisz grupę docelową.-->
<!--                        </h5>-->
<!--                        <label class="w-100">-->
<!--                          <div class="input-box mt-2">-->
<!--                            <b-textarea required rows="4" v-model="schoolForm.team_target"></b-textarea>-->
<!--&lt;!&ndash;                            <p>Opisz grupę docelową</p>&ndash;&gt;-->
<!--                            <small class="maxlength-label">{{getWordsLeft(schoolForm.team_target, 100, 'team_target')}}</small>-->
<!--                          </div>-->
<!--                        </label>-->
<!--                        <h5 class="mt-5">-->
<!--                          Sojusznicy. Z kim możecie współpracować, kogo poprosić o radę, pomoc, wsparcie, aby zrealizować swój pomysł, odpowiedzieć na postawione wyzwanie i wprowadzić zmiany? [max 100 słów]-->
<!--                        </h5>-->
<!--                        <label class="w-100">-->
<!--                          <div class="input-box mt-2">-->
<!--                            <b-textarea required rows="4" v-model="schoolForm.team_ally"></b-textarea>-->
<!--&lt;!&ndash;                            <p>Opisz sojusznika</p>&ndash;&gt;-->
<!--                            <small class="maxlength-label">{{getWordsLeft(schoolForm.team_ally, 100, 'team_ally')}}</small>-->
<!--                          </div>-->
<!--                        </label>-->
                        <h5 class="mt-5">
                          Jeśli pomysł został zgłoszony do innych konkursów lub jest to planowane w najbliższym czasie, prosimy o napisanie do jakich?
                        </h5>
                        <label class="w-100">
                          <div class="input-box mt-2">
                            <b-textarea rows="4" v-model="schoolForm.other_contests"></b-textarea>
                          </div>
                        </label>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-else-if="currentStep === 1">
              <b-col class="mt-5">
                <p class="text-18 text-center">
                  Aplikacja wypełniona!<br>
                  Teraz chcemy się tylko upewnić, że przeczytałeś/przeczytałaś regulamin.
                  <br>
                  Poprosimy Cię także o zaznaczenie zgód.
                </p>
                <p class="text-18 text-center">Pozostał Ci już tylko ostatni krok, jakim jest wysłanie zgłoszenia.</p>
                <div class="consent-box mt-6">
                  <b-row align-h="center">
                    <b-col cols="6">
                      <h4 class="mt-0 mb-0 text-center form-section-title yellow">Regulamin</h4>
                      <label class="input-control d-flex align-items-start mt-7">
                        <input class="mt-1" type="checkbox" required v-model="schoolForm.regulation_consent" />
                        <p class="mb-0">Oświadczam, że zapoznałem/zapoznałam się z <a href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf" target="_blank">regulaminem</a> 6. edcyji Solve for Tomorrow i akceptuję go.  Mam upoważnienie członków i członkiń zespołu do zaakceptowania regulaminu w ich imieniu.<span class="color-span">*</span></p>
                      </label>
                    </b-col>
                  </b-row>
                </div>
                <div class="consent-box mt-6">
                  <b-row align-h="center">
                    <b-col cols="6">
                      <h4 class="mt-0 mb-0 text-center form-section-title blue mb-7">Zgody</h4>
                      <label class="input-control d-flex align-items-start mt-0">
                        <input type="checkbox" required v-model="schoolForm.personal_data_consent" />
                        <p class="mb-0">Wyrażam zgodę na przetwarzanie moich danych osobowych w celach związanych z udziałem w programie Solve for Tomorrow. Treść zgody znajduje się w <a target="_blank" href="https://solvefortomorrow.pl/wp-content/uploads/2026/10/RegulaminSFT_6_edycja.pdf">regulaminie</a> programu. Potwierdzam zapoznanie się z informacją o przetwarzaniu danych osobowych zawartą w regulaminie 6. edycji programu Solve for Tomorrow. <span class="color-span">*</span></p>
                      </label>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row v-else-if="currentStep === 2">
              <b-col class="text-center mt-6">
                <h3 class="final-text" v-if="!errorAlert">Dziękujemy za wypełnienie formularza!<br><br>
                  Twoje zgłoszenie już do nas trafiło.<br>
                  Teraz potrzebujemy trochę czasu na jego analizę.<br><br>
                  Dziękujemy za przesłanie zgłoszenia do 5. edycji Solve for
                  Tomorrow. Aplikacja zostanie teraz oceniona przez Jury. Listę zespołów
                  zakwalifikowanych do półfinału SFT opublikujemy na stronie www programu do 28
                  listopada 2025 r
                </h3>
                <h3 v-else>
                  Ups... Coś poszło nie tak!<br />
                  Spróbuj ponownie później!
                </h3>
              </b-col>
            </b-row>
            <b-row v-if="this.wordsLimitIdea || this.wordsTeamChallenge || this.wordsTeamTarget || this.wordsTeamAlly">
              <b-col class="mt-5 mb-3 text-center">
                <h3 class="error">
                  Jedno z pól przekracza dostępną liczbę słów.
                </h3>
              </b-col>
            </b-row>
            <b-row v-if="this.emptyFields">
              <b-col class="mt-5 mb-3 text-center">
                <h3 class="error">
                  Nie wypełniono wszystkich pól lub są błędnie wypełnione!
                </h3>
              </b-col>
            </b-row>
            <b-row v-if="this.validEmail">
              <b-col class="mt-5 mb-3 text-center">
                <h3 class="error">
                  Jedno z pól email nie posiada poprawnego adresu email
                </h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="currentStep < 2" class="mt-6 mb-3 d-inline-flex justify-content-end" :class="[currentStep > 0 ? 'justify-content-between' : '']">
                <b-button v-if="currentStep > 0" @click="currentStep--" class="button-new-primary button-new-primary--left" variant="info">
                  <svg v-if="currentStep === 1" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12.5L19 12.5M5 12.5L11 18.5M5 12.5L11 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Wróć do kroku 1
                </b-button>
                <b-button class="ml-4 button-new-primary" type="submit" variant="primary">
                  <span>{{currentStep === 0 ? 'Krok 2' : 'Wyślij zgłoszenie' }}</span>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12.5L5 12.5M19 12.5L13 18.5M19 12.5L13 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </b-button>
              </b-col>
              <b-col v-else class="mt-6 mb-3 text-center">
                <router-link class="d-flex justify-content-center w-100 text-decoration-none" to="/"><b-button class="button-new-primary button-new-primary--big" variant="primary">Wróć na stronę główną SFT</b-button></router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </form>
  </section>
  </div>
</template>

<script>
import mainImage from '../../assets/media/images/register-samsung.jpg'
import wp_api_client from "@/store/wp_api_client";

const api = new wp_api_client(process.env.VUE_APP_API_URL)

const howDoYouKnowOptions = [
    // 'W szkole pojawiła się informacja o programie od Samsung (www, social media, pracownicy firmy)',
    'Do szkoły przyszedł mail o programie od organizatora',
    'Dzięki konkursowi Explory',
    // 'Konferencja Bohaterowie Marzeń w Chełmie',
  // 'Akcja Insipiracja Our Future Foundation',
  'Our Future Foundation',
    // 'Dzięki SGH',
    'Dzięki Centrum ElektroEkologii',
    // 'Dzięki Unicef',
    // 'Konferencja Inspiracje w Warszawie',
    'Mail z Kuratorium Oświaty',
    'Od zespołów uczestniczących w ubiegłych edycjach',
    'Od Alumnów Solve for Tomorrow',
    'Od innych nauczycieli, nauczycielek, którzy znają program lub brali w nim udział',
    'Od influencera, influencerki',
    'Do szkoły przyszedł plakat informujący o programie',
    'Social media',
    'Librus',
    'Od osób pracujących w firmie Samsung',
    'HackTheTopo – Game Jam w Topolówce',
    'Jobs of the Future 2026',
    'Gdańsk Model United Nations 2026',
];

const regexMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const voivodeships = [
      'dolnośląskie',
      'kujawsko-pomorskie',
      'lubelskie',
      'lubuskie',
      'łódzkie',
      'małopolskie',
      'mazowieckie',
      'opolskie',
      'podkarpackie',
      'podlaskie',
      'pomorskie',
      'śląskie',
      'świętokrzyskie',
      'warmińsko-mazurskie',
      'wielkopolskie',
      'zachodniopomorskie',
    ];
const teacherRoles = [
  'Dyrektor/ka',
  'Wicedyrektor/ka',
  'Nauczyciel/ka',
  'Bibliotekarz/rka',
  'Opiekun/ka świetlicy',
  'Inne'
];
const editions = [
  'Do 1 edycji',
  'Do 2 edycji',
  'Do 3 edycji',
  'Do 4 edycji',
  'Nie',
];
const schoolForm = {
  type_of_school: "Ponadpodstawowa",
  first_name: null,
  // last_name: null,
  email: null,
  phone: null,
  first_name_leader: null,
  email_leader: null,
  phone_leader: null,
  subjects: null,
  role: null,
  custom_role: null,
  editions: [],
  school_name:null,
  school_voivodeship:null,
  school_street:null,
  school_zip:null,
  school_city:null,
  team_members: [
    {
      firstname: '',
      // lastname: '',
      age: '',
      gender: '',
    },
    {
      firstname: '',
      // lastname: '',
      age: '',
      gender: '',
    },
    {
      firstname: '',
      // lastname: '',
      age: '',
      gender: '',
    },
    {
      firstname: '',
      // lastname: '',
      age: '',
      gender: '',
    },
  ],
  other_contests: '',
  // about_team: null,
  director_consent:false,
  parental_consent:false,
  team_subject_challenge:null,
  team_challenges:null,
  team_idea_short_description: null,
  // team_idea_description: null,
  // team_target: null,
  // team_ally: null,
  // team_goal: null,
  sft_find_out: null,
  sft_find_out_diffrent: null,
  regulation_consent: false,
  team_regulation_consent: false,
  personal_data_consent: false,
  personal_image_consent: false,
};
const universityForm = {
  type_of_school: null,
  first_name: null,
  // last_name: null,
  email: null,
  phone: null,
  subjects: null,
  role: null,
  school_name:null,
  school_voivodeship:null,
  school_street:null,
  school_zip:null,
  school_city:null,
  team_members: [
    {
      firstname: '',
      lastname: '',
      age: ''
    },
    {
      firstname: '',
      lastname: '',
      age: ''
    },
    {
      firstname: '',
      lastname: '',
      age: ''
    },
    {
      firstname: '',
      lastname: '',
      age: ''
    },
  ],
  about_team: null,
  director_consent:null,
  parental_consent:null,
  team_subject_challenge:null,
  team_challenges:null,
  team_idea_short_description: null,
  team_idea_description: null,
  // team_target: null,
  // team_ally: null,
  team_goal: null,
  sft_find_out: null,
  regulation_consent: null,
  // team_regulation_consent: null,
  personal_data_consent: null,
  personal_image_consent: null,
};

export default {
  name: "RegisterForm",
  data(){
    return {
      showModal: false,
      isSelectFocused: false,
      currentStep: 0,
      teamSize: 1,
      formSelected: 'school',
      voivodeships: voivodeships,
      teacherRoles: teacherRoles,
      editions: editions,
      schoolForm: JSON.parse(JSON.stringify(schoolForm)),
      universityForm: universityForm,
      mainImage: mainImage,
      activeIndex: 0,
      errorAlert: false,
      wordsLimitIdea:  false,
      wordsTeamChallenge: false,
      wordsTeamTarget: false,
      wordsTeamAlly: false,
      emptyFields: false,
      formSend: false,
      formTimeout: null,
      validEmail: false,
      emailValidTimeout: null,
      howDoYouKnowOptions: howDoYouKnowOptions,
    }
  },
  methods: {
    getWordsLeft(str, limit, el) {
      if(str) {
       const maxLengthSigns = 3000
       let wordsLeft = limit - str.split(' ').length
       let signs = str.length
       let signsLeft = maxLengthSigns > signs
       if(wordsLeft >= 0 && signsLeft) {
         switch (el) {
           case 'team_idea_short_description':
             this.wordsLimitIdea = false;
             break;
           case 'team_challenges':
             this.wordsTeamChallenge = false;
             break;
           case 'team_target':
             this.wordsTeamTarget = false;
             break;
           case 'team_ally':
             this.wordsTeamAlly = false;
             break;
         }
         return 'Pozostało ' + wordsLeft + ' słów';
       }
       else {
         switch (el) {
           case 'team_idea_short_description':
             this.wordsLimitIdea = true;
             break;
           case 'team_challenges':
             this.wordsTeamChallenge = true;
             break;
           case 'team_target':
             this.wordsTeamTarget = true;
             break;
           case 'team_ally':
             this.wordsTeamAlly = true;
             break;
         }
         return signsLeft ? 'Przekroczono limit słów o ' + wordsLeft*(-1)  : 'Przekroczono limit znaków';
       }
      }
      else {
        switch (el) {
          case 'team_idea_short_description':
            this.wordsLimitIdea = false;
            break;
          case 'team_challenges':
            this.wordsTeamChallenge = false;
            break;
          case 'team_target':
            this.wordsTeamTarget = false;
            break;
          case 'team_ally':
            this.wordsTeamAlly = false;
            break;
        }
        return 'Pozostało ' + limit + ' słów';
      }
    },
    nextStep(e) {
      e.preventDefault()
      if(this.currentStep === 1) this.handleFormSubmit()
      else  {
        if(this.checkEmail()) {
          this.validEmail = true;

          if (this.emailValidTimeout !== null) {
            clearTimeout(this.emailValidTimeout);
          }

          this.emailValidTimeout = setTimeout(() => {
            this.validEmail = false;
          }, 4000);
        } else if(this.schoolForm.editions.length === 0 || (!this.schoolForm.sft_find_out && !this.schoolForm.sft_find_out_diffrent)
            || !this.schoolForm.team_subject_challenge || this.validateFormValues(
                [
                    'custom_role',
                    'role',
                    'editions',
                    'personal_data_consent',
                    'personal_image_consent',
                    'regulation_consent',
                    'sft_find_out',
                    'sft_find_out_diffrent',
                    'subjects',
                    'team_members',
                    'other_contests',
                ]
            )) {
          this.validEmail = false;
          this.emptyFields = true;
          if (this.formTimeout !== null) {
            clearTimeout(this.formTimeout);
          }

          this.formTimeout = setTimeout(() => {
            this.emptyFields = false;
          }, 4000);

        }
        else if (!this.wordsLimitIdea && !this.wordsTeamChallenge && !this.team_target && !this.wordsTeamAlly && this.validatePhoneFormat(this.schoolForm.phone)
          && this.validatePhoneFormat(this.schoolForm.phone_leader)) {
          this.validEmail = false;
          this.emptyFields = false;
          this.currentStep++
        }
      }
    },
    handleFormSubmit() {
      this.currentStep++
      api.sendApplicationForm(this.formSelected === 'school' ? this.schoolForm : this.universityForm)
        .then((res) => {
          if(res.status !== 200) {
            this.errorAlert = true
          }
          this.formSend = true
        })
        .catch(e => {
          this.errorAlert = true
          console.log(e.response.data)
        })
    },
    validateFormValues(excludeFields) {
      for (const key in this.schoolForm) {
        if (!excludeFields.includes(key)) {
          const value = this.schoolForm[key];
          if (value === null || value === undefined || value === false || value === "") {
            console.log(key, value)
            return true;
          }
        }
      }
      return false;
    },
    validatePhoneFormat(phone) {
      const regex = /^\d{3} \d{3} \d{3}$/;

      return regex.test(phone);
    },
    checkEmail() {
      return !!(this.schoolForm.email_leader && !regexMail.test(this.schoolForm.email_leader)
          || this.schoolForm.email && !regexMail.test(this.schoolForm.email));
    },
    onFocus() {
      this.isSelectFocused = true;
    },
    onBlur() {
      this.isSelectFocused = false;
    },
    onSelectChange() {
      this.isSelectFocused = false;
      this.isSelectFocused = !this.isSelectFocused;
    },
    toggleDropdown() {
      this.isSelectFocused = !this.isSelectFocused;
    },
    formatZipCode(event) {
      let value = event.replace(/\D/g, '');
      if (value.length > 5) {
        return
      }
      if (value.length > 2) {
        value = value.slice(0, 2) + '-' + value.slice(2);
      }
      this.schoolForm.school_zip = value;
    },
    checkIfFormFilled() {
      if (this.isFormFilled()) {
        this.showModal = true
      } else {
        this.goBack();
      }
    },
    isFormFilled() {
      for (let key in this.schoolForm) {
        if (key !== 'type_of_school') {
          const value = this.schoolForm[key];

          if (typeof value === 'string' && value.trim() !== '') {
            return true;
          }

          if (Array.isArray(value) && value.length > 0 && key !== 'team_members') {
            return true;
          }

          if (typeof value === 'boolean' && value === true) {
            return true;
          }
        }
      }

      return this.schoolForm.team_members.some(member =>
        member.firstname.trim() !== '' || member.age.trim() !== ''
      );
    },
    goBack() {
      this.$router.push('/');
    },
    cancel() {
      this.showModal = false;
    },
    formatPhone(event) {
      let value = event.replace(/\D/g, "");

      value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1 $2 $3").trim();

      if (value.length > 11) {
        return
      }

      this.schoolForm.phone = value;
    },
    formatPhoneLeader(event) {
      let value = event.replace(/\D/g, "");

      value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1 $2 $3").trim();

      if (value.length > 11) {
        return
      }

      this.schoolForm.phone_leader = value;
    },
  },
  beforeDestroy() {
    this.schoolForm = JSON.parse(JSON.stringify(schoolForm));
  },
}
</script>

<style scoped lang="scss">
.form {
  position: relative;
  background-color: $main-bg;
  padding-top: 80px;
  padding-bottom: 80px;
  color: $main-color;
  overflow: hidden;
  min-height: 100vh;

  & label {
    margin-bottom: unset;
  }

  & .shape-1 {
    position: absolute;
    top: 0;
    left: 0;
    opacity: .2;
  }

  & .shape-2 {
    position: absolute;
    top: 130px;
    right: 0;

    &.step1 {
      top: 380px;
    }

    &.step2 {
      top: unset;
      bottom: 120px;
    }
  }

  & .shape-3 {
    position: absolute;
    top: 350px;
    right: 15%;
    opacity: .2;

    @include media-breakpoint-down(lg){
      display: none;
    }

    &.step1 {
      top: 490px;
    }

    &.step2 {
      top: unset;
      bottom: -10%;
    }
  }

  & h5 {
    font-family: "Samsung Sharp Sans";
    font-size: .875em;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
    margin-top: 32px;
  }

  .box-return {
    display: flex;
    gap: 4px;
    align-items: center;
    margin-left: -12px;
    margin-bottom: 40px;

    &--point {
      cursor: pointer;
    }

    & p {
      margin-bottom: 0;
      font-size: 1.125em;
      font-style: normal;
      font-weight: 500;
      line-height: 25px;
    }

    & img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }

  & .regular-text {
    font-family: "Samsung Sharp Sans";
    font-size: .875em;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
  }

  & .regular-big-text {
    font-family: "Samsung Sharp Sans";
    font-size: 1em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
  }

  & .regular-consent {
    font-family: "Samsung Sharp Sans";
    font-size: .78em;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;
  }

  & .margin-16 {
    margin-top: 16px;

    & p {
      margin-bottom: 0;
    }
  }

  &-title {
    font-size: 1.75em;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }

  &-head {
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__link {
      text-align: center;
      font-size: 1.25em;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      text-decoration-line: underline;
      color: $main-color;
    }

    &__box {

      & p {
        text-align: center;
        font-family: "Samsung Sharp Sans";
        font-size: 1.25em;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 32px;
        margin-bottom: 0;
      }
    }
  }

  &-content {
    position: relative;
    padding: 48px 0 64px 0;
    margin-top: 62px;
    background-color: $white;
    border-radius: 20px;
  }
}

.main-image {
  height: 500px;
  width: 100%;
  object-fit: cover;
}
.main-header {
  font-weight: 700;
  color: white;
  font-size: 48px;
  @include media-breakpoint-down(sm) {
    left: 2%;
    font-size: 32px;
  }
}
.link-statute {
  color: black;
  text-decoration: underline;
}
.team-size-btn {
  width: 120px;
  text-align: center;
  cursor: pointer;
  border: 2px solid black;
  border-radius: 20px;
  padding: 16px;
  &.active {
    border-color: #A18037;
  }
}
label{
  position: relative;

  textarea:focus + .maxlength-label {
    color: #C50000;
  }

  .maxlength-label{
    position: absolute;
    left: 0;
    bottom: -20px;
    //color: #C50000;
  }
}
.form-type-buttons {
  margin-top: 6rem;
  margin-bottom: 6rem;
  button {
    max-width: 100%;
    padding-left: 2rem;
    padding-right: 2rem;
    font-weight: lighter;
  }
}
.form-section-title {
  text-align: center;
  position: relative;
  font-size: 1.5em;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 96px;

  &--small-margin {
    margin-bottom: 40px;
  }

  &:after {
    content: "";
    position: absolute;
    top: calc(100% + 16px);
    left: 0;
    width: 100%;
    height: 3px;
  }
    &.yellow {
      &:after {
        background-color: #FCC157;
      }
    }
    &.blue {
      &:after {
        background-color: #007CC2;
      }
    }
    &.red {
      &:after {
        background-color: #FF4337;
      }
    }
}
.hr_container {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
}
.number {
  background: $main-bg;
  position: relative;
  z-index: 1;
  width: 94px;
  height: 38px;
  font-size: 1.25em;
  font-style: normal;
  line-height: 36px;
  font-weight: 500;
  color: $main-gray;
  border: 2px solid $main-gray;
  border-radius: 100%;
  font-family: Samsung Sharp Sans;
  text-align: center;
  margin: 0 auto;
  &-line {
    width: 100%;
    height: 1px;
    background: $main-gray;
  }
  &-text {
    font-size: .9415em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: $main-gray;

    &.finished {
      color: $main-color;
    }

    &.active {
      color: $main-color;
    }

    &:first-child {
      margin-left: 0;
    }

    &:nth-child(2) {
      margin-left: 30px;
    }

    &:last-child {
      margin-left: 30px;
    }
  }
  &.active{
    font-weight: 700;
    color: $second-blue;
    border-color: $second-blue;
  }
  &.finished{
    color: #878424;
    border-color: #878424;
  }
}
.form-control, .custom-select {
  padding: 8px 0;
  border: none;
  height: calc(1.5em + 1rem);
  border-bottom: 1px solid $second-gray;
  box-shadow: none;
  border-radius: 0!important;
  color: $third-gray!important;
  margin-top: 12px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: $white!important;

  &::-ms-expand {
    display: none;
  }

  & option {
    color: $main-color!important;
  }
  &::placeholder{
    color: #979797;
  }
}
.input {
  border-radius: 10px;

  &.input-number-star {
    padding-left: 12px;
  }
}

.label {
  font-size: 16px;
  font-weight: 500;
  font-family: "Samsung Sharp Sans";
}

.select {
  font-weight: 500;
  font-family: "Samsung Sharp Sans";
}

.box {

  .active {
    svg path {
      fill: #A18037
    }
  }
}

.input-control {
  display: flex;
  align-items: center;
  margin-top: 32px;
  gap: 6px;
  font-size: 18px;
  font-family: "Samsung Sharp Sans";
  padding-left: 0;
  padding-right: 0;

  &--small-margin {
    margin-top: 24px;
  }

  & div {
    display: flex;
  }

  & a {
    color: $main-color;
    text-decoration: underline;
  }
  & p {
    font-size: .78em;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &.img {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: #000;
    width: 25px;
    height: 25px;
    border: 1px solid #007CC2;
    border-radius: 0.15em;
    display: grid;
    place-content: center;

    &::before {
      content: "";
      width: 25px;
      height: 25px;
    }

    &:checked::before {
      border: none;
      border-radius: 0.15em;
      background: #007CC2 no-repeat center url("../../assets/media/images/mark-blue.svg");
    }
  }
}

.star-box {
  position: relative;
}

.star {
  position: absolute;
  top: 40%;
  left: 6%;
  font-weight: 700;
  font-size: 17px;
  font-family: "Samsung Sharp Sans";
  color: #FF4337;

  &-red {
    color: #FF4337;
  }
}

.input-box {
  position: relative;
  margin-top: 32px;

  & p {
    font-family: "Samsung Sharp Sans";
    font-size: .875em;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: $main-color;
    padding-top: 0;
    margin-bottom: 0;

    & .color {
      color: #C50076;
    }
  }

  &-instruction {
    display: block;
    font-family: "Samsung Sharp Sans";
    color: $main-color;
    font-size: .8em;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    margin-top: 8px;
  }

  & input:focus + p, & input:not(:placeholder-shown) + p  {
    display: block;
    top: -22%;
  }

  & textarea:focus + p, & textarea:not(:placeholder-shown) + p {
    display: block;
    top: -18%;
  }

  & input:focus::placeholder, & textarea:focus::placeholder {
    opacity: 0;
  }

  & input {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid $second-gray;
    box-shadow: none;
    padding: 8px 0;
    height: calc(1.5em + 1rem);
    margin-top: 12px;
    color: $main-color!important;

    &::placeholder {
      font-size: .95em;
      font-style: normal;
      font-weight: 400;
      line-height: 26px;
      color: $third-gray;
    }
  }

  &.select-box {
    & .select-icon {

      &::after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5889 13.0892C10.2635 13.4146 9.73586 13.4146 9.41042 13.0892L4.41042 8.08917C4.08498 7.76374 4.08498 7.2361 4.41042 6.91066C4.73586 6.58523 5.26349 6.58523 5.58893 6.91066L9.99967 11.3214L14.4104 6.91066C14.7359 6.58523 15.2635 6.58523 15.5889 6.91066C15.9144 7.2361 15.9144 7.76374 15.5889 8.08917L10.5889 13.0892Z' fill='%23393947'/%3E%3C/svg%3E%0A");
        position: absolute;
        right: 0;
        top: 73%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
      }

      &.rotate::after {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  & .radio-box {
    gap: 32px;
    & label {
      margin-bottom: 0;
    }

    & input[type="radio"] {
      height: auto;
      margin: 0;
      padding: 0;
      border-bottom: none;
      background: none;
      cursor: pointer;

      &::before {
        width: 28px;
        height: 28px;
        border-radius: 0;
        background: no-repeat center url("../../assets/media/images/radio-blue.svg");
      }

      &:checked::before {
        border-radius: 0;
        background: no-repeat center url("../../assets/media/images/radio-mark-blue.svg");
      }
    }
  }
}

.radio-box-2 {
  margin-top: 16px;
  align-items: center;
  gap: 6px;

  & input[type="radio"] {
    height: auto;
    margin: 0;
    padding: 0;
    border-bottom: none;
    background: none;
    cursor: pointer;
    border: none;

    &::before {
      width: 28px;
      height: 28px;
      border-radius: 0;
      background: no-repeat center url("../../assets/media/images/radio-blue.svg");
    }

    &:checked::before {
      border-radius: 0;
      background: no-repeat center url("../../assets/media/images/radio-mark-blue.svg");
    }
  }
}

.color-span {
  color: #FF4337;
}

.link {
  font-family: "Samsung Sharp Sans";
  font-size: .875em;
  font-style: normal;
  font-weight: bold;
  line-height: 20px;
  color: $main-color;
  padding-top: 0;
  margin-bottom: 0;
  text-decoration: underline;
  margin-left: 32px;

  &:visited, &:hover {
    color: $main-color;
  }
}

.button-new-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px 9px 24px;
  background-color: $secondary;
  border: none;
  margin-right: -12px;
  line-height: normal;
  color: $white;
  transition: all .4s ease;

  &--big {
    line-height: 32px;
    padding: 9px 32px;
    margin-right: 0;
  }

  &--left {
    padding: 9px 24px 9px 16px;
  }

  &:hover {
    background-color: #13588A;
  }
}

.error {
  color: #df2019;
}

::v-deep .modal-dialog {
  max-width: 736px;

  .modal-content {
    padding: 48px 40px;
    border-radius: 8px;
    max-width: 736px;
    width: 100%;
    font-size: 1.065em;
    font-style: normal;
    font-weight: 700;
    color: $main-color;

    & .close {
      display: none;
    }

    & p {
      font-size: 1.06em;
      font-style: normal;
      font-weight: 400;
      margin-bottom: 0;
    }

    & .btn-modal {
      padding: 8px 24px;
      background-color: $secondary;
      color: $white;
      font-size: .95em;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      border: none;

      &.red {
        background-color: #DC0000;
      }
    }

    & .modal-header {
      border: none;
      padding: 0;
      margin-bottom: 16px;
    }

    & .modal-body {
      padding: 0;
      margin-bottom: 32px;
    }

    & .modal-footer {
      border: none;
      padding: 0;
    }
  }
}

.text-18 {
  font-family: "Samsung Sharp Sans";
  font-size: 1.125em;
  font-style: normal;
  font-weight: 500;
  color: $main-color;
}

.consent-box {
  padding: 48px 48px 64px 48px;
  background-color: $white;
  border-radius: 20px;
}

.final-text {
  font-family: "Samsung Sharp Sans";
  font-size: 1.25em;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: $main-color;
}
</style>
